import React, { FunctionComponent } from "react";
import {
  styled,
  css,
  Block,
  Text,
  Button,
  Icon,
  IButtonProps,
} from "../../../seenspire-library";
import { Meta } from "../../interfaces";

// @TODO Use generic interface for pagination, and move it to library.
export interface IPaginationProps {
  current?: number;
  pagesInRange: number[];
  next: number;
  previous: number;
  onNavigate: (pageNumber: number) => void;
}

interface IPaginationDefaults {
  numItemsPerPage: number;
  current: number;
}

const PAGINATION_DEFAULTS = {
  numItemsPerPage: 10,
  current: 1,
};

const PaginationButton = styled(Button).attrs({})<{
  current?: boolean;
  disabled?: boolean;
}>`
  background-color: ${({ theme, current }) =>
    current ? theme.colors.gray.lightest : theme.colors.white.base};
  height: 40px;
  min-width: 40px;
  border-color: hsla(0, 0%, 0%, 0.08);
  &:first-child {
    min-width: 110px;
    padding-left: 14px;
    padding-right: 20px;
  }
  &:last-child {
    min-width: 110px;
    padding-left: 20px;
    padding-right: 14px;
  }
  ${({ theme, current }) =>
    current &&
    `
	&:hover {
		background-color: ${theme.colors.gray.lightest};
	}
`}
  ${({ theme, disabled }) =>
    disabled &&
    `
    opacity: 0.5;
    color: ${theme.colors.gray.base};
    fill: ${theme.colors.gray.base};
    background-color: ${theme.colors.gray.lightest};
		border-color: ${theme.colors.gray.lightest};
		&:hover {
      background-color: ${theme.colors.gray.lightest};
      border-color: ${theme.colors.gray.lightest};
    }
  `}
`;

const PaginationContainer = styled(Block)``;

const Pagination: FunctionComponent<{
  meta?: Meta;
  onNavigate: (pageNumber: number) => void;
}> = ({ meta, onNavigate }) => {
  if (
    !meta ||
    meta.currentItemCount === 0 ||
    meta.totalCount <= meta.numItemsPerPage
  )
    return null;
  const buttonsProps: IButtonProps = {
    buttonType: "outline",
    elementWidth: "free",
    elementHeightBase: false,
    fontSize: "small",
  };

  const handelNavigationClick = (pageNumber: number) => {
    meta.current !== pageNumber && onNavigate(pageNumber);
  };

  return (
    <PaginationContainer
      display="grid"
      direction="column"
      justifyContent="center"
      gridGap={10}
    >
      <PaginationButton
        disabled={meta.previous ? false : true}
        onClick={() => handelNavigationClick(meta.previous)}
        {...buttonsProps}
      >
        <Icon name="arrowLeft" />
        <Block>previous</Block>
      </PaginationButton>

      {/* @TODO Show limited nuber than the whole range */}
      {meta.pagesInRange.map((page) => (
        <PaginationButton
          current={page === meta.current}
          onClick={() => handelNavigationClick(page)}
          {...buttonsProps}
          key={page}
        >
          {page}
        </PaginationButton>
      ))}

      <PaginationButton
        visibility={meta.next ? "visible" : "hidden"}
        onClick={() => handelNavigationClick(meta.next)}
        {...buttonsProps}
      >
        <Block>next</Block>
        <Icon name="arrowRight" />
      </PaginationButton>
    </PaginationContainer>
  );
};

export { Pagination, PAGINATION_DEFAULTS };
